<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-tabView>
        <p-tabPanel header="{{ 'PAGADURIA.LBL_GENERALPAGADURIA' | translate }}">
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_CODIGO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.codigo }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_NIT" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.numeroDocumento }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_DV" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.digitoVerificacion }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_RAZONSOCIAL" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.razonSocial }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_TIPOSOCIEDAD" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.tipoSociedad }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_SECTOR" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.sector }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_DIRECCION" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.direccion }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_CIUDAD" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ divisionPolitica.descripcionDivisonPolitica }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_DEPARTAMENTO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ departamento.descripcionDivisonPolitica }}</strong></label>
            <label
              class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_TIPTELEFONOUNO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.tipoTelefonoUno }}</strong></label>
          </div>
          <div class="grid">
            <label
              class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_TELEFONOCONTACUNO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.telefonoContacto1 }}</strong></label>
            <label
              class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_CORREOELECTRONICO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.correoElectronico }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_CARGOCONTACTO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.cargoContacto }}</strong></label>
            <label
              class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_NOMBRECONTACTO" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.nombreContacto }}</strong></label>
          </div>
          <div class="grid">
            <label
              class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_TIPTELEFONODOS" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.tipoTelefonoDos }}</strong></label>
            <label
              class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_TELEFONOCONTACDOS" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.telefonoContacto2 }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_FONDOPENSION" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{
                pagaduria.indicadorFondoPension ? "Activo" : "Inactivo"
              }}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_CODIGOSHIVAM" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.codigoShivam }}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ "PAGADURIA.LBL_ENTIDAD" | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{ pagaduria.empresa }}</strong></label>
          </div>
        </p-tabPanel>
        <p-tabPanel header="{{ 'PAGADURIA.LBL_CONDICIONES' | translate }}" [disabled]="!pagaduria">
          <app-pagaduria-condiciones-listado [pagaduria]="pagaduria" [detalle]="true">
          </app-pagaduria-condiciones-listado>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton
        (click)="regresar()"></button>
    </div>
  </div>
</div>
